// MEALUP: buy a subscription gift on its own (sections/mu-sub-timeline.liquid).
// A gift card with a linked product opens a small window: photo of the page's flavor, price, text, size when the
// product has sizes, and one button that adds it to the cart. The cart drawer and the cart count update in place,
// the visitor stays on the page; the item then goes with the order (the main button goes to checkout with the whole cart).
(function () {
  if (window.muGiftBuy) return;
  window.muGiftBuy = true;

  function dialogFor(el) {
    const section = el.closest('.shopify-section');
    return section && section.querySelector('dialog.mu-gb');
  }

  function refresh(state) {
    if (!state || !state.sections) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && state.sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
      const source = html.querySelector('.drawer__inner');
      const target = drawer.querySelector('.drawer__inner');
      if (source && target) target.innerHTML = source.innerHTML;
      drawer.classList.remove('is-empty');
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && state.sections['cart-icon-bubble']) {
      const src = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (src) bubble.innerHTML = src.innerHTML;
    }
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-mu-gift-open]');
    if (open) {
      const dlg = dialogFor(open);
      const tpl = document.getElementById(open.dataset.muGiftOpen);
      if (!dlg || !tpl) return;
      const slot = dlg.querySelector('[data-mu-gift-slot]');
      slot.innerHTML = '';
      slot.appendChild(tpl.content.cloneNode(true));
      dlg._opener = open;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('mu-gb-open');
      return;
    }

    const close = e.target.closest('[data-mu-gift-close]');
    const dlgClick = e.target.matches && e.target.matches('dialog.mu-gb') ? e.target : null;
    if (close || dlgClick) {
      const dlg = close ? close.closest('dialog.mu-gb') : dlgClick;
      if (dlg) dlg.close();
      return;
    }

    const add = e.target.closest('[data-mu-gift-add]');
    if (!add || add.getAttribute('aria-busy') === 'true') return;
    const body = add.closest('.mu-gb__body');
    const variant = body.querySelector('[data-mu-gift-variant]');
    const err = body.querySelector('.mu-gb__error');
    add.setAttribute('aria-busy', 'true');
    err.hidden = true;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
    })
      .then((r) => r.json())
      .then((state) => {
        add.removeAttribute('aria-busy');
        if (state.status) {
          err.textContent = state.description || state.message || (window.cartStrings && window.cartStrings.error) || '';
          err.hidden = false;
          return;
        }
        refresh(state);
        add.hidden = true;
        const size = body.querySelector('.mu-gb__size');
        if (size) size.hidden = true;
        const done = body.querySelector('.mu-gb__done');
        done.hidden = false;
        const link = done.querySelector('a');
        if (link) link.focus();
      })
      .catch(() => {
        add.removeAttribute('aria-busy');
        err.textContent = (window.cartStrings && window.cartStrings.error) || '';
        err.hidden = false;
      });
  });

  document.addEventListener('close', (e) => {
    if (!e.target.matches || !e.target.matches('dialog.mu-gb')) return;
    document.documentElement.classList.remove('mu-gb-open');
    if (e.target._opener) e.target._opener.focus();
  }, true);
})();
